import React, { Component } from 'react';
import { inject } from 'mobx-react';

import RestorePasswordFormStep0 from './RestorePasswordFormStep0';
import RestorePasswordFormStep1 from './RestorePasswordFormStep1';

import values from './formValues';
import validation from './formValidation';
import { FormStore } from 'core/forms/FormStore';

const formStore = new FormStore(values, validation);

@inject('userStore')
class RestorePassword extends Component {
  componentWillMount() {
    formStore.values.token = this.props.match.params.token || null;
  }
  render() {
    return (
      <div className="restore-password">
        {!formStore.values.token && (
          <RestorePasswordFormStep0
            history={this.props.history}
            userStore={this.props.userStore}
            formStore={formStore}
          />
        )}

        {!!formStore.values.token && (
          <RestorePasswordFormStep1
            history={this.props.history}
            userStore={this.props.userStore}
            formStore={formStore}
          />
        )}
      </div>
    );
  }
}

export default RestorePassword;



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/RestorePassword.jsx